import createQueryDuck from '@/redux/query';

import serializer from '../serializer';
import { getCurrentQuery } from '../utils';

export default createQueryDuck('user_aggregation', {
  getRoot: getCurrentQuery,
  serializer,
});
